export default function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/minifyCSSString.js
// module id = 257
// module chunks = 0